export default __webpack_public_path__ + "static/inter-500.latin-7215373943d85111db38224de7d9f506.woff2";